import { lazy } from 'react';
import { authRoles } from 'src/app/auth';

const ProfileApp = lazy(() => import('./ProfileApp'));
const NewAccountUser = lazy(() => import('./tabs/NewAccountUser'));

const profileAppConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: authRoles.allUser,
  routes: [
    {
      path: 'apps/profile',
      element: <ProfileApp />,
    },
    {
      path: 'apps/profile/new/user',
      element: <NewAccountUser />,
    },
    {
      path: 'apps/profile/edit/user/:id',
      element: <NewAccountUser />,
    },
  ],
};

export default profileAppConfig;
